module.exports = __webpack_public_path__ + "img/icon2.54902cb6.png";